import get from 'lodash/get';
import siteData from './site_data_util';
import baseSeoUtil from './base_seo_util';
import { isAdvertorial } from '../../views/components/advertorial/advertorial';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData[site] || {};
  const siteHumanReadable = get(siteConf, '[og:site_name]');
  const tag = get(state, 'tagFeaturedFeed.tag') || {};
  const tagName = get(tag, 'name');
  const slug = get(tag, 'slug');
  const tags = get(state, 'tagAllFeed.data[0].tags');

  const data = baseSeoUtil({
    site,
    siteConf,
    title: tagName
      ? `Fast Company posts tagged ${tagName}`
      : `${siteHumanReadable}`,
    url: `https://www.${site}.com/section/${slug}`,
    description: `Fast Company articles and posts tagged ${tagName} with a unique editorial focus on innovation in technology, leadership, and design.`,
    articleSection: tagName
  });

  if (isAdvertorial(tags)) {
    data.meta.push({
      name: 'ROBOTS',
      content: 'NOINDEX,FOLLOW'
    });
  }

  return data;
}



// WEBPACK FOOTER //
// ./src/utils/seo_utils/tag_seo_util.js